<template><div><h1>1px 解决方案</h1>
<div class="tip">
<p>1px 方案在 VUX 组件内应用广泛，包括 <code>Grid</code>, <code>ButtonTab</code>, <code>XTable</code>, <code>XButton</code>, <code>Cell</code> 等等。</p>
<p>利用 <code>Flexbox</code> + <code>1px</code> 你可以实现复杂的宫格布局。</p>
</div>
<h2>引入</h2>
<p>在你项目的<code>App.vue</code>引入，组件内不需要再重复引入。</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">style</span> <span class="hljs-attr">lang</span>=<span class="hljs-string">"less"</span>&gt;</span><span class="undefined">
@import '~vux/src/styles/1px.less';
</span><span class="hljs-tag">&lt;/<span class="hljs-name">style</span>&gt;</span>
</code></pre>
<h2>可用类名：</h2>
<ul>
<li><code>vux-1px-l</code> 左边框</li>
<li><code>vux-1px-r</code> 右边框</li>
<li><code>vux-1px-t</code> 上边框</li>
<li><code>vux-1px-b</code> 下边框</li>
<li><code>vux-1px-tb</code> 上下边框</li>
<li><code>vux-1px</code> 全边框</li>
</ul>
</div></template><script>
export default {
  head: {"title":"1px 解决方案 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// 1px-150.vue?79008a66